const Multiselect = () => (
  <>
    <path
      fill="currentColor"
      d="M2.096 12.704a.48.48 0 0 1 .006-.707.52.52 0 0 1 .354-.163.48.48 0 0 1 .354.162l3.896 3.896.5-.5a.5.5 0 0 1 .263-.005q.147.03.283.167.165.165.163.354a.5.5 0 0 1-.169.354l-.48.48a.8.8 0 0 1-.566.24.77.77 0 0 1-.565-.24zm10.254 3.182 8.846-8.846a.48.48 0 0 1 .707.006q.16.165.163.354a.48.48 0 0 1-.162.354l-8.988 8.988a.78.78 0 0 1-.566.242.78.78 0 0 1-.566-.242l-4.038-4.038a.5.5 0 0 1-.15-.341.48.48 0 0 1 .15-.367q.166-.165.357-.165t.357.165zm3.898-8.127-4.237 4.237a.5.5 0 0 1-.34.15.48.48 0 0 1-.367-.15.5.5 0 0 1-.165-.357q0-.19.165-.356l4.236-4.237a.5.5 0 0 1 .342-.15.48.48 0 0 1 .366.15q.165.166.165.357a.5.5 0 0 1-.165.356"
    />
  </>
)
export default Multiselect
